const { APP_DOMAIN } = Config;

import React from "react";

export default function WizardLogotype(props) {
    const ref = React.useRef(null);

    const { show, right, fadeUp, desktop, mobile, center } = props;

    React.useEffect(() => {
        const dom = ref.current;

        if (right !== undefined) {
            dom.classList.add("positioning");

            dom._right_ = dom.style.getPropertyValue("right");

            if (right !== "center") {
                dom.style.setProperty("right", dom._right_);
            } else {
                dom.style.setProperty("right", `calc(50% - ${dom.offsetWidth / 2}px)`);
            }
        }
    }, [right]);

    React.useEffect(() => {
        const dom = ref.current;

        dom.classList.toggle("show", !!show);
        dom.classList.toggle("fade-up", !!fadeUp);
        dom.classList.toggle("mobile", !!mobile);
        dom.classList.toggle("desktop", !!desktop);
        dom.classList.toggle("center", !!center);
    }, [show, fadeUp, desktop]);

    React.useEffect(() => {
        const dom = ref.current;

        if (dom.parentElement !== document.body) {
            document.body.appendChild(dom);
        }

        return () => {
            dom.parentElement && dom.parentElement.removeChild(dom);
        };
    }, [ref]);

    return (
        <div ref={ref} className="wizard-logotype">
            {APP_DOMAIN}
        </div>
    );
}
